// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"VideoPlayer_videoPlayer__34pjn","displayNone":"VideoPlayer_displayNone__2MIcc","playButton":"VideoPlayer_playButton__2fvE4"};